document.addEventListener("DOMContentLoaded", function() {
  const timers = document.querySelectorAll(".time-deal-wrapper");
  timers.forEach(timer => {
    const endDate = new Date(timer.dataset.endDate).getTime();

    function updateTimer() {
      const now = new Date().getTime();
      const distance = endDate - now;

      if (distance < 0) {
        timer.querySelector(".time-deal-countdown").innerHTML = "<span class='deal-ended'>Deal Ended</span>";
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      timer.querySelector(".time-days").textContent = days.toString().padStart(2, '0');
      timer.querySelector(".time-hours").textContent = hours.toString().padStart(2, '0');
      timer.querySelector(".time-minutes").textContent = minutes.toString().padStart(2, '0');
      timer.querySelector(".time-seconds").textContent = seconds.toString().padStart(2, '0');
    }

    updateTimer();
    setInterval(updateTimer, 1000);
  });
});